<template>
  <div class="luck-draw" v-if="tmpType == 1">
		<div class="frequency">
			今日剩余抽奖次数
		</div>
		<div class="box">
			<div class="box-item" 
				v-for="(item,index) in list" 
				:key="index"
			>
				<img class="item-icon" src="https://img3.quanyou.com.cn/joy/group1/M00/12/4A/rB4ChmKyfwiAHzc3AAB6CftVG-w982.png" model="widthFix"/>
				<div class="name">现金红包</div>
			</div>
		</div>
		<img class="bottom-img"  src="https://img3.quanyou.com.cn/joy/group1/M00/12/4C/rB4ChWKygeWAX6_MAAFSXDSLXME487.png" />
		<div class="name-list">
			<div class="header-box">
				<img class="icon1" src="https://img3.quanyou.com.cn/joy/group1/M00/12/4A/rB4ChmKyhHeAb4zuAAAKR18NbGI814.png"/>
				<div class="title">中奖名单</div>
				<img class="icon1" src="https://img3.quanyou.com.cn/joy/group1/M00/12/4A/rB4ChmKyhHeAb4zuAAAKR18NbGI814.png" />
			</div>
			<div class="list-box"></div>
		</div>
	</div>
	<div class="card" v-else>
    <el-image class="img-demo" :src="imgList[tmpType-2]" fit="cover"></el-image>
  </div>
</template>

<script>

export default {
	props: {
		tmpType: {
			type: String,
			default: 1
		}
	},
	data() {
		return {
			list: [1,2,3,4,5,6,7,8,9],
			imgList: [
				'https://img3.quanyou.com.cn/joyNew/group1/M00/1D/91/rB8LrWU3MOCAAOqSAAJ3Ybz4yKg215.png',
				require('@/assets/images/styleTwo/lotterly.png'),
				require('@/assets/images/styleFour/cj.png'),
				require('@/assets/images/styleFive/cj.png'),
			  'https://img3.quanyou.com.cn/joyNew/group1/M00/C4/CF/rB8LrWlth4iAM0-EABBGp0S1Drc197.png'
			]
		}
	},
};
</script>

<style lang="stylus" scoped>
.card
  font-size 0
  .img-demo
    width 100%
.luck-draw {
	display: flex;
	align-items: center;
	flex-direction: column;
	width: 100%;
	height: 778px;
	background: url('https://img3.quanyou.com.cn/joy/group1/M00/12/4B/rB4ChWKyc5mAW4ncAAPrklX6hOQ138.png');
	background-size: 100% 100%;
	.frequency {
		font-size: 11px;
		color:#FCE9BE;
		margin-top: 107px;
	}
	.box {
		display: flex;
		flex-flow: wrap
		width: 76%;
		margin-top: 48px;
		.box-item {
			display: flex;
			flex-direction: column;
			align-items: center;
			width: 82px;
			height: 88px;
			margin: 0 5px 5px 0;
			background: url('https://img3.quanyou.com.cn/joy/group1/M00/12/4A/rB4ChmKyfk6AcXXZAAAeWJ9ZO2U570.png');
			background-size: 100% 100%;
			.item-icon {
				width: 92px;
				height: 68px;
			}
			.name {
				color: #C55C2E;
				font-size: 10px;
				margin-top: 5px;
			}
		}
		.box-item:nth-child(3n) {
			margin-right: 0;
		}
	}
	.bottom-img {
		width: 265px;
		height: 81px;
		margin-top: 30px;
	}
	.name-list {
		display: flex;
		flex-direction: column;
		align-items: center;
		width: 74%;
		height: 120px;
		margin-top: 55px;
		.header-box {
			display: flex;
			align-items: center;
			.icon1 {
				width: 21px;
				height: 10px;
			}
			.title {
				color: #F4D897;
				font-size: 13px;
				margin: 0 5px;
			}
		}
		.list-box {
			width: 100%;
			height: 100px;
			.list {
				display: flex;
				justify-content: space-between;
				color: #FFE5A8;
				font-size: 9px;
				line-height: 15px;
				.time, .phone, .name {
					width: 35%;
					text-align: center;
				}
			}

		}
	}
}
</style>
